// import ClassNames from "classnames"
import React, { useEffect } from "react"
// import { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { HashRouter } from "react-router-dom"

import "core-js/stable"
import "bootstrap/dist/css/bootstrap.min.css"
import "styles/iconfonts/material-icons.css"
import "styles/app.scss"

import "babel-polyfill"
import "core-js/stable"
import "regenerator-runtime/runtime"
import "react-app-polyfill/ie11"
import "react-app-polyfill/stable"

import store from "redux/store"
// import { AsiaMapContainer } from "components/organisms/modals/asiaMap"
import Main from "components/pages/main"
import { checkIsSp, setThemeFunction, checkIsBrowser } from "utils/util"
import LandScape from "components/atoms/text/landscape"
import SessionTimeOut from "components/pages/main/sessionTimeOut"

const target = document.querySelector("#root")
const browser = checkIsBrowser()

export const App: React.FC = () => {
  useEffect(() => {
    const newScript = document.createElement("script")
    newScript.setAttribute("type", "text/javascript")
    newScript.setAttribute("src", `./config/ext_config.js?t=${Date.now()}`)
    document.body.appendChild(newScript)
    //htmlタグにpc/spクラス付与
    const htmlClass = document.querySelector("html").classList
    htmlClass.add(checkIsSp() ? "sp" : "pc")
  }, [])

  //IEはまとめてクラス付与できないため個別の副作用でクラスを付与
  useEffect(() => {
    const htmlClass = document.querySelector("html").classList
    htmlClass.add(browser)
  }, [browser])
  // const [splash, changeSplash] = useState(false)
  // const [move, changeMove] = useState(false)
  // useEffect(() => {
  //   setTimeout(() => {
  //     changeMove(true)
  //   }, 1500)
  //   setTimeout(() => {
  //     changeSplash(false)
  //   }, 2000)
  // }, [])
  // return splash ? (
  //   <div className="splash">
  //     <div className={ClassNames({ move: move })}>
  //       <div className="splash-border" />
  //       <AsiaMapContainer />
  //     </div>
  //   </div>
  // ) : (
  //   <BrowserRouter>
  //     <Main />
  //   </BrowserRouter>
  // )
  return (
    <Provider store={store}>
      <HashRouter>
        <LandScape />
        <SessionTimeOut />
        <Main />
      </HashRouter>
    </Provider>
  )
}

ReactDOM.render(<App />, target)
